/** 会员标识类型：VIP 优先；非 VIP 且 ad_free 时才展示 AD-Free */
export type MembershipBadgeKind = "luxury" | "synergy" | "adFree" | null

export type MembershipBadgeInput = {
  vip?: boolean | null
  vipType?: number | null
  adFree?: boolean | null
}

/**
 * 解析当前用户应展示的会员标识。
 * - vip：按 vip_type 展示 Luxury(1) / Synergy·Royal(2)
 * - 非 vip 且 ad_free：展示 AD-Free
 * - 其余：无标识
 */
export const getMembershipBadgeKind = ({
  vip,
  vipType,
  adFree,
}: MembershipBadgeInput): MembershipBadgeKind => {
  if (vip) {
    return vipType === 2 ? "synergy" : "luxury"
  }
  if (adFree) return "adFree"
  return null
}

export const MEMBERSHIP_ICON_SRC: Record<Exclude<MembershipBadgeKind, null>, string> = {
  luxury: "/icons/Luxury.svg",
  synergy: "/icons/Synergy.svg",
  adFree: "/icons/AdFree.svg",
}
